
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sets/[id]",
      function () {
        return require("private-next-pages/sets/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sets/[id]"])
      });
    }
  